import React from 'react';
import { Alert } from '../../../ui';

export const Alerts = () => (
	<>
		<h2 id="alerts">Alerts</h2>

		<Alert
			title="Traffic advisory"
			subtitle="Last updated: Sep 6, 2018 at 4:00"
		>
			<p>
				Allow extra time to drive to and from the terminal. While adjusting to
				new traffic patterns drive more cautiously and follow directional
				signage.
			</p>
		</Alert>
	</>
);
